import { createFileRoute } from '@tanstack/react-router';
import { CampaignOverviewRouteView } from '@/pages/workspaces/automations/[campaignId]/overview/routing';

function CampaignOverviewRoute() {
  const { campaignId } = Route.useParams();
  return <CampaignOverviewRouteView campaignId={campaignId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/')({
  component: CampaignOverviewRoute,
});
